<template>
<router-link :to="{name: 'teacherPage', params:{tid: this.teacher.id}}" class="teacher-item">
  <like-teacher :teacher="teacher"></like-teacher>
  <img :src="imgUrl" :alt="teacher.name">
    <h5>{{teacher.name}}</h5>
    <current-tag v-for="current in getCurrent"
     :key="current.id" :current="current">
    </current-tag>
</router-link>

</template>

<script>
import CurrentTag from "@/components/CurrentTag.vue";
import LikeTeacher from "./LikeTeacher.vue";

export default {
  name: `TeacherItem`,
  props: {
    teacher: Object
  },

  components: {
    CurrentTag,
    LikeTeacher
  },

  computed: {
    imgUrl() {
      return this.$store.state.initialData.basepath + this.teacher.img;
    },
    getCurrent() {
      const curList = [];
      this.$store.state.initialData.currents.forEach((c) => {
        this.teacher.currents.forEach((tc) => {
          if (parseInt(tc.tag, 10) === parseInt(c.id, 10)) {
            curList.push(c);
          }
        });
      });
      return curList;
    }
  }
};
</script>

<style lang="scss">
$purple: #656b85;
$white: #ffffff;
$pinky: #fd7170;
$black: #191919;

.teacher-item {
  display: inline-block;
  position: relative;
  text-align: right;
  padding-right: 110px;
  min-height: 110px;
  width: auto;
  margin: 0 30px 50px;
  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
    transition: all 300ms ease;
  }
  h5 {
    color: $black;
    font-size: 16px;
    margin-top: 30px;
    transition: color 300ms ease;
  }
  p {
    font-size: 13px;
    margin: 0;
  }
  &:hover,
  &:focus {
    text-decoration: none;
    img {
      box-shadow: 0 0 15px $purple;
    }
    h5 {
      color: $pinky;
    }
  }
}

@media screen and (min-width: 375px) {
  .teacher-item {
    width: 300px;
  }
}
</style>
